/* Achat rapide Methappro : styles + logique. Configuration lue dans window.MP_QUICK_ADD_CONFIG (snippets/mp-quick-add-script.liquid). */
  if (!window.__mpQuickAdd) {
    window.__mpQuickAdd = true;
    (function () {
      var MPC = window.MP_QUICK_ADD_CONFIG || {};
      var LOCALE = MPC.locale || 'fr';
      var CURRENCY = MPC.currency || 'EUR';
      var CART_URL = MPC.cartUrl || '/cart';

      var STYLE_ID = 'mp-quick-add-styles';
      var CSS = [
        /* ---- bloc achat rapide ---- */
        '.mp-quick-add{margin-top:12px;display:block;line-height:1.3;}',
        '.mp-quick-add *{box-sizing:border-box;}',
        '.mp-quick-add__form{margin:0;}',
        '.mp-quick-add__select{display:block;width:100%;margin:0 0 6px;padding:9px 10px;border:1px solid #E6EAE0;border-radius:8px;background:#fff;color:#26301F;font-family:inherit;font-size:14px;line-height:1.3;min-height:44px;}',
        '.mp-quick-add__select:focus{outline:2px solid #BD9009;outline-offset:1px;border-color:#BD9009;}',
        '.mp-quick-add__select:focus-visible{outline:2px solid #BD9009;outline-offset:1px;border-color:#BD9009;}',
        /* ---- prix a l'unite de mesure ---- */
        '.mp-quick-add__unit{margin:0 0 8px;font-size:12.5px;line-height:1.35;color:#66705F;}',
        '.mp-quick-add__unit[hidden]{display:none;}',
        '.mp-quick-add__unit-price{color:#26301F;font-weight:700;}',
        '.mp-quick-add__unit-save{color:#3A5232;font-weight:700;}',
        /* ---- ligne stepper + bouton ---- */
        '.mp-quick-add__row{display:flex;flex-wrap:nowrap;align-items:stretch;gap:8px;}',
        '.mp-quick-add__qty{display:flex;flex:0 0 auto;align-items:stretch;border:1px solid #E6EAE0;border-radius:8px;background:#F4F8EF;}',
        '.mp-quick-add__qty-btn{display:flex;align-items:center;justify-content:center;width:40px;min-width:40px;min-height:44px;padding:0;margin:0;border:0;border-radius:7px;background:transparent;color:#26301F;font-family:inherit;font-size:19px;font-weight:600;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;}',
        '.mp-quick-add__qty-btn:hover{background:#E6EAE0;color:#3A5232;}',
        '.mp-quick-add__qty-btn:focus-visible{outline:2px solid #BD9009;outline-offset:-2px;}',
        '.mp-quick-add__qty-input{width:44px;min-width:44px;min-height:44px;padding:0 2px;margin:0;border:0;border-left:1px solid #E6EAE0;border-right:1px solid #E6EAE0;background:#fff;color:#26301F;font-family:inherit;font-size:15px;font-weight:700;line-height:1.2;text-align:center;-moz-appearance:textfield;appearance:textfield;}',
        '.mp-quick-add__qty-input::-webkit-outer-spin-button,.mp-quick-add__qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}',
        '.mp-quick-add__qty-input:focus-visible{outline:2px solid #BD9009;outline-offset:-2px;}',
        /* ---- bouton principal : garde la priorite visuelle ---- */
        '.mp-quick-add__btn{display:flex;flex:1 1 auto;min-width:0;align-items:center;justify-content:center;gap:8px;min-height:44px;padding:10px 12px;margin:0;border:1px solid #5E7B54;border-radius:8px;background:#5E7B54;color:#fff;font-family:inherit;font-size:15px;font-weight:600;line-height:1.2;text-align:center;cursor:pointer;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;transition:background-color .18s ease,border-color .18s ease,color .18s ease;}',
        '.mp-quick-add__btn:hover:not(:disabled){background:#3A5232;border-color:#3A5232;color:#fff;}',
        '.mp-quick-add__btn:focus-visible{outline:2px solid #BD9009;outline-offset:2px;}',
        '.mp-quick-add__btn:disabled{cursor:default;}',
        '.mp-quick-add__btn.is-loading{background:#7C9472;border-color:#7C9472;color:#fff;}',
        '.mp-quick-add__btn.is-added{background:#3A5232;border-color:#3A5232;color:#fff;}',
        '.mp-quick-add__btn.is-error{background:#BD9009;border-color:#BD9009;color:#26301F;}',
        '.mp-quick-add__label{pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
        /* ---- zone de retour (erreurs) ---- */
        '.mp-quick-add__status{margin:8px 0 0;font-size:12.5px;font-weight:600;line-height:1.35;color:#BD9009;}',
        '.mp-quick-add__status:empty{display:none;margin:0;}',
        /* ---- lien devis ---- */
        '.mp-quick-add__quote{display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;padding:10px 14px;border:1px solid #5E7B54;border-radius:8px;background:#fff;color:#26301F;font-family:inherit;font-size:15px;font-weight:600;line-height:1.2;text-align:center;text-decoration:none;transition:background-color .18s ease,color .18s ease;}',
        '.mp-quick-add__quote:hover{background:#3A5232;border-color:#3A5232;color:#fff;text-decoration:none;}',
        '.mp-quick-add__quote:focus-visible{outline:2px solid #BD9009;outline-offset:2px;}',
        '@media (max-width:749px){.mp-quick-add__btn,.mp-quick-add__quote{min-height:46px;font-size:15px;}.mp-quick-add__select{min-height:46px;font-size:15px;}.mp-quick-add__qty-btn{min-height:46px;}.mp-quick-add__qty-input{min-height:46px;font-size:16px;} }',
        /* ---- toast de confirmation ---- */
        '.mp-toast{position:fixed;right:20px;bottom:20px;z-index:100000;width:340px;max-width:calc(100vw - 32px);border-radius:12px;background:#3A5232;color:#fff;box-shadow:0 12px 32px rgba(38,48,31,.30);font-family:inherit;line-height:1.35;opacity:0;transform:translateY(14px);transition:opacity .22s ease,transform .22s ease;}',
        '.mp-toast[hidden]{display:none;}',
        '.mp-toast.is-visible{opacity:1;transform:translateY(0);}',
        '.mp-toast *{box-sizing:border-box;}',
        '.mp-toast__inner{position:relative;padding:14px 52px 14px 16px;}',
        '.mp-toast__title{margin:0 0 4px;font-size:15px;font-weight:700;color:#fff;}',
        '.mp-toast__check{color:#BD9009;font-weight:700;}',
        '.mp-toast__product{margin:0;font-size:13.5px;font-weight:600;color:#fff;}',
        '.mp-toast__product:empty{display:none;}',
        '.mp-toast__meta{margin:3px 0 0;font-size:12.5px;color:#E6EAE0;}',
        '.mp-toast__meta:empty{display:none;}',
        '.mp-toast__actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;}',
        '.mp-toast__btn{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:8px 14px;border:1px solid transparent;border-radius:8px;font-family:inherit;font-size:14px;font-weight:600;line-height:1.2;text-align:center;text-decoration:none;cursor:pointer;-webkit-appearance:none;appearance:none;}',
        '.mp-toast__btn--primary{background:#BD9009;border-color:#BD9009;color:#26301F;}',
        '.mp-toast__btn--primary:hover{background:#D3A215;border-color:#D3A215;color:#26301F;text-decoration:none;}',
        '.mp-toast__btn--ghost{background:transparent;border-color:#E6EAE0;color:#fff;}',
        '.mp-toast__btn--ghost:hover{background:#26301F;border-color:#26301F;color:#fff;}',
        '.mp-toast__btn:focus-visible{outline:2px solid #BD9009;outline-offset:2px;}',
        '.mp-toast__close{position:absolute;top:4px;right:4px;display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;border:0;border-radius:8px;background:transparent;color:#E6EAE0;font-family:inherit;font-size:22px;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;}',
        '.mp-toast__close:hover{background:#26301F;color:#fff;}',
        '.mp-toast__close:focus-visible{outline:2px solid #BD9009;outline-offset:-2px;}',
        '@media (max-width:749px){.mp-toast{left:12px;right:12px;bottom:12px;width:auto;max-width:none;} .mp-toast__actions .mp-toast__btn{flex:1 1 auto;} }',
        '@media (prefers-reduced-motion:reduce){.mp-toast{transition:none;} .mp-quick-add__btn{transition:none;} }',
        /* ---- masque les formulaires d'ajout natifs du theme dans la carte ---- */
        '.card-information__wrapper > product-form.product-form{display:none !important;}',
        '.card-information__wrapper .product-hover-info > product-form.product-form{display:none !important;}'
      ].join('');

      function injectStyles() {
        if (document.getElementById(STYLE_ID)) return;
        var el = document.createElement('style');
        el.id = STYLE_ID;
        el.appendChild(document.createTextNode(CSS));
        (document.head || document.documentElement).appendChild(el);
      }
      injectStyles();

      function closest(node, selector) {
        if (!node) return null;
        if (node.nodeType !== 1) node = node.parentElement;
        return node && node.closest ? node.closest(selector) : null;
      }

      /* =====================================================================
         1. Extraction de l'unite de mesure depuis le libelle de la variante
         ===================================================================== */

      /* nombre : 1 000 / 21 000 / 1,14 / 25,2 / 500  (espace fine ou insecable admise) */
      var NUM = '(\\d{1,3}(?:[\\u00a0\\u202f\\s]\\d{3})+(?:[.,]\\d+)?|\\d+(?:[.,]\\d+)?)';
      var CONTENANT = '(?:sacs?|sachets?|big\\s*bags?|bidons?|f[u\\u00fb]ts?|cuves?|palettes?)';

      /* « 57 sacs de 20 kg » : le plus specifique, teste en premier */
      var RE_COMPOSITE = new RegExp(NUM + '\\s*' + CONTENANT + '\\s*de\\s*' + NUM + '\\s*(kg|kilogrammes?|kilos?|tonnes?|t|litres?|l)\\b', 'i');
      var RE_TONNE = new RegExp(NUM + '\\s*(?:tonnes?|t)\\b', 'i');
      var RE_KG = new RegExp(NUM + '\\s*(?:kilogrammes?|kilos?|kg)\\b', 'i');
      var RE_LITRE = new RegExp(NUM + '\\s*(?:litres?|l)\\b', 'i');
      var RE_COUNT = new RegExp(NUM + '\\s*(palettes?|big\\s*bags?|sacs?|bidons?|f[u\\u00fb]ts?|unit[e\\u00e9]s?|pi[e\\u00e8]ces?)\\b', 'i');

      function toNum(raw) {
        if (!raw) return NaN;
        return parseFloat(String(raw).replace(/[  \s]/g, '').replace(',', '.'));
      }

      function singular(word) {
        return String(word).toLowerCase().replace(/\s+/g, ' ').replace(/s$/, '');
      }

      /*
        Renvoie { qty: <nombre dans l'unite de base>, family: 'kg' | 'L' | '<contenant>' }
        ou null si aucune unite fiable n'a pu etre extraite.
        Priorite : composite > tonnes > kilos > litres > simple comptage.
      */
      function parseMeasure(text) {
        if (!text) return null;
        var s = String(text);
        var m, v;

        m = RE_COMPOSITE.exec(s);
        if (m) {
          var count = toNum(m[1]);
          var each = toNum(m[2]);
          var u = String(m[3]).toLowerCase();
          if (count > 0 && each > 0) {
            if (u.charAt(0) === 't') return { qty: count * each * 1000, family: 'kg' };
            if (u.charAt(0) === 'k') return { qty: count * each, family: 'kg' };
            return { qty: count * each, family: 'L' };
          }
        }

        m = RE_TONNE.exec(s);
        if (m) { v = toNum(m[1]); if (v > 0) return { qty: v * 1000, family: 'kg' }; }

        m = RE_KG.exec(s);
        if (m) { v = toNum(m[1]); if (v > 0) return { qty: v, family: 'kg' }; }

        m = RE_LITRE.exec(s);
        if (m) { v = toNum(m[1]); if (v > 0) return { qty: v, family: 'L' }; }

        m = RE_COUNT.exec(s);
        if (m) { v = toNum(m[1]); if (v > 0) return { qty: v, family: singular(m[2]) }; }

        return null;
      }

      function fmtMoney(value, decimals) {
        try {
          return new Intl.NumberFormat(LOCALE, {
            style: 'currency',
            currency: CURRENCY,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(value);
        } catch (e) {
          return value.toFixed(decimals).replace('.', ',') + ' €';
        }
      }

      /*
        Analyse toutes les options d'un select.
        Regle de prudence : si UNE SEULE variante n'est pas interpretable, ou si les
        variantes ne partagent pas la meme unite, on n'affiche rien du tout.
      */
      function buildUnitState(select) {
        if (select.__mpUnitState !== undefined) return select.__mpUnitState;

        var state = null;
        var opts = select.options;
        var n = opts.length;

        if (n >= 2) {
          var family = null;
          var list = [];
          var ok = true;
          for (var i = 0; i < n; i++) {
            var label = opts[i].getAttribute('data-mp-variant-title') || '';
            var parsed = parseMeasure(label);
            if (!parsed || !(parsed.qty > 0)) { ok = false; break; }
            if (family === null) family = parsed.family;
            else if (family !== parsed.family) { ok = false; break; }
            list.push(parsed);
          }
          if (ok && family) {
            var refCents = parseInt(opts[0].getAttribute('data-mp-price-cents'), 10);
            var ref = (refCents > 0 && list[0].qty > 0) ? (refCents / 100) / list[0].qty : null;
            /* meme nombre de decimales pour tous les paliers d'un meme produit */
            var decimals = (ref && ref > 0 && ref < 1) ? 3 : 2;
            state = { list: list, unit: family, ref: ref, decimals: decimals };
          }
        }

        select.__mpUnitState = state;
        return state;
      }

      function renderUnitPrice(select) {
        var form = closest(select, '[data-mp-quick-form]');
        if (!form) return;
        var box = form.querySelector('[data-mp-unit]');
        if (!box) return;

        function clear() { box.textContent = ''; box.hidden = true; }

        var state = buildUnitState(select);
        var idx = select.selectedIndex;
        if (!state || idx < 0 || !state.list[idx]) return clear();

        var cents = parseInt(select.options[idx].getAttribute('data-mp-price-cents'), 10);
        if (!(cents > 0)) return clear();

        var unitPrice = (cents / 100) / state.list[idx].qty;
        if (!isFinite(unitPrice) || unitPrice <= 0) return clear();

        var decimals = state.decimals || (unitPrice >= 1 ? 2 : 3);
        box.textContent = '';

        var priceSpan = document.createElement('span');
        priceSpan.className = 'mp-quick-add__unit-price';
        priceSpan.textContent = fmtMoney(unitPrice, decimals) + '/' + state.unit;
        box.appendChild(priceSpan);

        if (state.ref && state.ref > 0) {
          var save = Math.round((1 - unitPrice / state.ref) * 100);
          if (save >= 1) {
            var saveSpan = document.createElement('span');
            saveSpan.className = 'mp-quick-add__unit-save';
            saveSpan.textContent = ' — économie de ' + save + ' %';
            box.appendChild(saveSpan);
          }
        }

        box.hidden = false;
      }

      /* balayage : un seul passage par select, y compris pour les cartes clonees */
      function scanSelects() {
        var list = document.querySelectorAll('[data-mp-variant-select]');
        for (var i = 0; i < list.length; i++) {
          if (list[i].__mpScanned) continue;
          list[i].__mpScanned = true;
          renderUnitPrice(list[i]);
        }
      }

      var scanTimer = null;
      function scheduleScan() {
        if (scanTimer) return;
        scanTimer = setTimeout(function () { scanTimer = null; scanSelects(); }, 150);
      }

      /* =====================================================================
         2. Toast de confirmation : cree une seule fois, reutilise ensuite
         ===================================================================== */

      var toastEl = null;
      var toastTimer = null;
      var toastHideTimer = null;

      function buildToast() {
        if (toastEl && document.body && document.body.contains(toastEl)) return toastEl;
        if (!document.body) return null;

        toastEl = document.createElement('div');
        toastEl.className = 'mp-toast';
        toastEl.id = 'mp-quick-add-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        toastEl.setAttribute('aria-atomic', 'true');
        toastEl.hidden = true;

        var inner = document.createElement('div');
        inner.className = 'mp-toast__inner';

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'mp-toast__close';
        close.setAttribute('data-mp-toast-close', '');
        close.setAttribute('aria-label', 'Fermer la notification');
        close.textContent = '×';

        var title = document.createElement('p');
        title.className = 'mp-toast__title';
        var check = document.createElement('span');
        check.className = 'mp-toast__check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓ ';
        title.appendChild(check);
        title.appendChild(document.createTextNode('Ajouté au panier'));

        var prod = document.createElement('p');
        prod.className = 'mp-toast__product';
        prod.setAttribute('data-mp-toast-product', '');

        var meta = document.createElement('p');
        meta.className = 'mp-toast__meta';
        meta.setAttribute('data-mp-toast-meta', '');

        var actions = document.createElement('div');
        actions.className = 'mp-toast__actions';

        var cartLink = document.createElement('a');
        cartLink.className = 'mp-toast__btn mp-toast__btn--primary';
        cartLink.href = CART_URL || '/cart';
        cartLink.textContent = 'Voir le panier';

        var keep = document.createElement('button');
        keep.type = 'button';
        keep.className = 'mp-toast__btn mp-toast__btn--ghost';
        keep.setAttribute('data-mp-toast-close', '');
        keep.textContent = 'Continuer mes achats';

        actions.appendChild(cartLink);
        actions.appendChild(keep);

        inner.appendChild(close);
        inner.appendChild(title);
        inner.appendChild(prod);
        inner.appendChild(meta);
        inner.appendChild(actions);
        toastEl.appendChild(inner);
        document.body.appendChild(toastEl);

        return toastEl;
      }

      function hideToast() {
        if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
        if (!toastEl) return;
        toastEl.classList.remove('is-visible');
        if (toastHideTimer) clearTimeout(toastHideTimer);
        toastHideTimer = setTimeout(function () {
          if (toastEl && !toastEl.classList.contains('is-visible')) toastEl.hidden = true;
        }, 260);
      }

      /* un seul toast a la fois : le contenu est ecrase et le delai reinitialise */
      function showToast(productTitle, variantTitle, qty) {
        var el = buildToast();
        if (!el) return;

        if (toastHideTimer) { clearTimeout(toastHideTimer); toastHideTimer = null; }
        if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }

        /* on demasque AVANT d'ecrire : une region aria-live masquee n'est pas annoncee */
        el.hidden = false;

        var prod = el.querySelector('[data-mp-toast-product]');
        var meta = el.querySelector('[data-mp-toast-meta]');
        if (prod) prod.textContent = productTitle || '';

        var parts = [];
        if (variantTitle) parts.push(variantTitle);
        parts.push('Quantité : ' + qty);
        if (meta) meta.textContent = parts.join(' · ');

        void el.offsetWidth; /* force le reflow pour rejouer la transition */
        el.classList.add('is-visible');

        toastTimer = setTimeout(hideToast, 6000);
      }

      /* =====================================================================
         3. Prix affiche sur la carte lors du changement de conditionnement
         ===================================================================== */

      function updatePrice(root, option) {
        var scope = closest(root, '.card-information__wrapper') || closest(root, '.card-wrapper');
        if (!scope) return;
        var priceEl = scope.querySelector('.price');
        if (!priceEl) return;

        var newPrice = option.getAttribute('data-mp-price') || '';
        var newCompare = option.getAttribute('data-mp-compare') || '';
        if (!newPrice) return;

        var mains = priceEl.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
        for (var i = 0; i < mains.length; i++) mains[i].textContent = newPrice;

        var compares = priceEl.querySelectorAll('.price__compare s');
        for (var j = 0; j < compares.length; j++) compares[j].textContent = newCompare;

        if (newCompare) {
          priceEl.classList.add('price--on-sale');
        } else {
          priceEl.classList.remove('price--on-sale');
        }
      }

      /* =====================================================================
         4. Panier
         ===================================================================== */

      function refreshCartCount() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = cart.item_count;
            var targets = document.querySelectorAll(
              '.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .cart-count, #CartCount, .site-header__cart-count'
            );
            for (var i = 0; i < targets.length; i++) targets[i].textContent = count;
            document.dispatchEvent(new CustomEvent('mp:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () { /* le compteur reste inchange, l'ajout a bien eu lieu */ });
      }

      function getQtyInput(form) { return form.querySelector('[data-mp-qty-input]'); }

      function readQty(form) {
        var input = getQtyInput(form);
        var v = input ? parseInt(input.value, 10) : 1;
        if (!isFinite(v) || v < 1) v = 1;
        return v;
      }

      function setQty(form, value) {
        var input = getQtyInput(form);
        if (!input) return;
        if (!isFinite(value) || value < 1) value = 1;
        input.value = String(value);
      }

      function currentVariantTitle(form) {
        var select = form.querySelector('[data-mp-variant-select]');
        var title = '';
        if (select && select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
          title = select.options[select.selectedIndex].getAttribute('data-mp-variant-title') || '';
        } else {
          var hidden = form.querySelector('[data-mp-variant-id]');
          title = hidden ? (hidden.getAttribute('data-mp-variant-title') || '') : '';
        }
        if (title === 'Default Title') title = '';
        return title;
      }

      function restore(btn, label, defaultLabel) {
        btn.classList.remove('is-loading', 'is-added', 'is-error');
        label.textContent = defaultLabel;
        btn.disabled = false;
        btn.removeAttribute('data-mp-busy');
        btn.removeAttribute('aria-busy');
      }

      function quickAdd(form) {
        var btn = form.querySelector('[data-mp-add]');
        /* anti double-clic : une requete a la fois par carte */
        if (!btn || btn.disabled || btn.getAttribute('data-mp-busy') === '1') return;

        var input = form.querySelector('[data-mp-variant-id]');
        var variantId = input && input.value;
        if (!variantId) return;

        var qty = readQty(form);
        setQty(form, qty);

        var status = form.querySelector('[data-mp-status]');
        var label = btn.querySelector('[data-mp-add-label]') || btn;
        var defaultLabel = btn.getAttribute('data-mp-label-default') || 'Ajouter au panier';
        var productTitle = form.getAttribute('data-mp-product-title') || '';
        var variantTitle = currentVariantTitle(form);

        if (status) status.textContent = '';
        btn.setAttribute('data-mp-busy', '1');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');
        label.textContent = 'Ajout…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [ { id: parseInt(variantId, 10), quantity: qty } ] })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.removeAttribute('aria-busy');
            label.textContent = 'Ajouté ✓';
            showToast(productTitle, variantTitle, qty);
            refreshCartCount();
            setTimeout(function () { restore(btn, label, defaultLabel); }, 2200);
          })
          .catch(function (err) {
            /* message renvoye par Shopify (rupture de stock, quantite indisponible...) */
            var msg = '';
            if (err && typeof err === 'object') {
              if (err.description) msg = err.description;
              else if (err.status && err.message) msg = err.message;
            }
            msg = String(msg || '').replace(/<[^>]*>/g, '').trim();
            if (!msg) msg = 'Ajout impossible pour le moment. Merci de réessayer.';
            if (status) status.textContent = msg;

            /* le bouton revient tout de suite dans son etat initial : nouvelle tentative possible */
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            label.textContent = defaultLabel;
            btn.disabled = false;
            btn.removeAttribute('data-mp-busy');
            btn.removeAttribute('aria-busy');
            setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
          });
      }

      /* =====================================================================
         5. Delegation d'evenements au document : le JS n'est attache qu'une fois
         ===================================================================== */

      document.addEventListener('change', function (e) {
        var select = closest(e.target, '[data-mp-variant-select]');
        if (!select) return;
        var form = closest(select, '[data-mp-quick-form]');
        if (!form) return;

        var option = select.options[select.selectedIndex];
        if (!option) return;

        var hidden = form.querySelector('[data-mp-variant-id]');
        if (hidden) hidden.value = option.value;

        var status = form.querySelector('[data-mp-status]');
        if (status) status.textContent = '';

        var btn = form.querySelector('[data-mp-add]');
        var label = btn && (btn.querySelector('[data-mp-add-label]') || btn);
        if (btn && label) {
          if (option.getAttribute('data-mp-available') === 'false') {
            btn.disabled = true;
            label.textContent = 'Indisponible';
          } else if (btn.getAttribute('data-mp-busy') !== '1') {
            btn.disabled = false;
            label.textContent = btn.getAttribute('data-mp-label-default') || 'Ajouter au panier';
          }
        }

        select.__mpScanned = true;
        renderUnitPrice(select);
        updatePrice(select, option);
      });

      /* normalisation de la quantite saisie au clavier */
      document.addEventListener('change', function (e) {
        var input = closest(e.target, '[data-mp-qty-input]');
        if (!input) return;
        var form = closest(input, '[data-mp-quick-form]');
        if (!form) return;
        setQty(form, parseInt(input.value, 10));
      });

      /*
        Phase de capture : notre gestionnaire s'execute avant ceux du theme,
        stopPropagation empeche donc reellement l'ouverture de la fiche produit
        ou du quick-view depuis l'interieur du bloc d'achat rapide.
      */
      document.addEventListener('click', function (e) {
        var target = e.target;

        /* --- toast --- */
        if (closest(target, '[data-mp-toast-close]')) {
          e.preventDefault();
          e.stopPropagation();
          hideToast();
          return;
        }
        if (closest(target, '.mp-toast')) return; /* le lien « Voir le panier » navigue normalement */

        /* --- bloc d'achat rapide --- */
        var wrap = closest(target, '.mp-quick-add');
        if (!wrap) return;
        if (closest(target, '[data-mp-quote]')) return; /* lien devis : navigation normale */

        var minus = closest(target, '[data-mp-qty-minus]');
        var plus = closest(target, '[data-mp-qty-plus]');
        var addBtn = closest(target, '[data-mp-add]');
        var form = closest(target, '[data-mp-quick-form]');

        if (!minus && !plus && !addBtn) {
          /* select, champ quantite, textes : on bloque seulement la carte */
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (!form) return;

        if (minus) { setQty(form, readQty(form) - 1); return; }
        if (plus) { setQty(form, readQty(form) + 1); return; }
        quickAdd(form);
      }, true);

      /* repli : validation au clavier (Entree) sur le formulaire */
      document.addEventListener('submit', function (e) {
        var form = closest(e.target, '[data-mp-quick-form]');
        if (!form) return;
        e.preventDefault();
        e.stopPropagation();
        quickAdd(form);
      });

      /* fermeture du toast a la touche Echap */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        if (toastEl && !toastEl.hidden) hideToast();
      });

      /* =====================================================================
         6. Initialisation
         ===================================================================== */

      function init() {
        buildToast();  /* la region aria-live existe des le depart */
        scanSelects();
        if (window.MutationObserver) {
          /* un seul observateur pour toute la page : gere onglets et carrousels */
          new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
  }
